import React, { useEffect } from 'react';

// noorpassportservices.com/appointment -> official USPS passport appointment scheduler.
// A short, friendly address we can put in emails; it forwards the visitor immediately.
const TARGET = 'https://tools.usps.com/rcas.htm';
export function AppointmentPage() {
  useEffect(() => {
    const t = setTimeout(() => {
      window.location.replace(TARGET);
    }, 400);
    return () => clearTimeout(t);
  }, []);
  return <div className="max-w-xl mx-auto px-4 py-16 text-center" data-id="element-501" data-mp="3t03cxa0ig05c">
      <h1 className="text-2xl font-semibold mb-3" data-id="element-502" data-mp="3o7adn1nt9k0n">Passport appointment</h1>
      <p className="mb-6" data-id="element-503" data-mp="3j8qnsq63jo30">Taking you to the official USPS appointment scheduler…</p>
      <a href={TARGET} className="inline-block px-5 py-3 rounded-full bg-brand-textPrimary text-white" data-id="element-504" data-mp="3j6e7ehfzlls2">
        Book your official appointment here
      </a>
    </div>;
}